import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import { translate } from 'react-i18next';

import DataService from 'lib/DataService';

import { theme } from 'lib/styles';
import {
	Container,
	Section,
	Title,
	TitleInput,
	Info,
	Toggle,
	ToggleLink,
	ToggleIcon,
	ToggleName
} from './styles'
import {
	HideBelowWidth
} from '../styles';

import UserContext from 'contexts/User';
import BrochureContext from 'contexts/Brochure';
import BuildingsContext from 'contexts/Buildings';

const Api = new DataService();


class Brochure extends React.Component {

	state = {
		generatingPdf: false,
		pdfUrl: false,
	}

	componentDidMount() {
		this.mounted = true;
	}

	componentWillUnmount() {
		this.mounted = false;
	}

	generatePdf = (brochureId) => {
		if(!this.state.generatingPdf) {
			this.setState({ generatingPdf: true, pdfUrl: '' });

			const quality = 'large';

			Api.getPdf({ brochureId, quality })
				.then(response => {
					if(this.mounted) {
						console.log(response);
						this.setState({ generatingPdf: false });

						if (response.result.pdf) {
							this.setState({ pdfUrl: response.result.pdf });
						}
					}
				});
		}
	}

	openPdf = () => {
		window.open(this.state.pdfUrl);
		this.setState({ pdfUrl: false });
	}

	render() {
		const { t, lng } = this.props;

		return (
			<ThemeProvider theme={theme}>
				<BuildingsContext.Consumer>
					{ buildings => (
						<BrochureContext.Consumer>
							{brochure => {

								if (brochure === null) {
									return null;
								}

								const {
									modify_time,
									create_time,
									building: buildingSlug
								} = brochure;
								const time = modify_time === '-' ? create_time : modify_time;
								const buildingData = buildings.find(building => building.slug === buildingSlug);
								let name = brochure.name;

								if ('i18n' in brochure && lng in brochure.i18n) {
									name = brochure.i18n[lng].name;
								}

								return (
									<UserContext.Consumer>
										{user => {

											const brochureEditable = brochure.type === 'normal' || user.can.update.master();

											return (
												<Container>
													<Section>
														<HideBelowWidth width="1500px">
															{ buildingData.name !== '' &&
																<Title>{buildingData.name}</Title>
															}
															<Info>{buildingData.address}, {buildingData.zip_code}, {buildingData.city}</Info>
														</HideBelowWidth>
													</Section>
													<Section>
														<div style={{ position: 'relative' }}>
															{
																brochureEditable ?
																	<React.Fragment>
																		<Title style={{ visibility: 'hidden', whiteSpace: 'nowrap' }}>{name}</Title>
																		<TitleInput
																			value={name}
																			onChange={event => {
																				const value = event.target.value;

																				brochure.name = value;
																				brochure.i18n[lng].name = value;

																				this.props.updateBrochureHandler(brochure);

																			}}
																			onBlur={event => {
																				const value = event.target.value;

																				brochure.name = value;
																				brochure.i18n[lng].name = value;

																				this.props.updateBrochureHandler(brochure);

																				Api.updateBrochure({ brochureId: brochure.id, data: { name: value } })
																					.then(res => {
																						console.log(res);
																					})

																			}}
																		/>
																	</React.Fragment>:
																	<Title>{name}</Title>
															}
															<Info>{time}</Info>
														</div>
													</Section>
													<Section>
														<Toggle onClick={this.props.togglePageListHandler}>
															<ToggleIcon className="icon" icon="show-sidebar" />
															<ToggleName>{t('header/brochure/Show pages')}</ToggleName>
														</Toggle>
													</Section>
													<Section>
														{
															brochureEditable &&
															<Toggle onClick={() => this.props.toggleControlsHandler()}>
																<ToggleIcon className="icon" icon="cog" />
																<ToggleName>{t('header/brochure/Page settings')}</ToggleName>
															</Toggle>
														}
													</Section>
													<Section>
														<Toggle onClick={() => {
															if(!this.state.generatingPdf) {
																if(this.state.pdfUrl) {
																	this.openPdf();
																} else {
																	this.generatePdf(brochure.id);
																}
															}
														}}>
															<ToggleIcon
																className="icon"
																icon={this.state.generatingPdf ? 'refresh' : 'download-02'}
																spin={this.state.generatingPdf}
															/>
															<ToggleName>{t(this.state.pdfUrl ? 'brochure/PDF/generate/open' : 'brochure/PDF/generate')}</ToggleName>
														</Toggle>
													</Section>
													<Section>
														<ToggleLink href={`${this.props.baseUrl}/${lng}/e/${brochure.id}/${brochure.i18n[lng].slug}/`} target="_blank">
															<ToggleIcon className="icon" icon="share-02" />
															<ToggleName>{t('header/brochure/Web brochure')}</ToggleName>
														</ToggleLink>
													</Section>
												</Container>
											)}}
									</UserContext.Consumer>
								)}}
						</BrochureContext.Consumer>
					)}
				</BuildingsContext.Consumer>
			</ThemeProvider>
		);
	}
}

Brochure.propTypes = {
	t: PropTypes.func,
	lng: PropTypes.string,
	brochure: PropTypes.shape({
		modify_time: PropTypes.string,
		create_time: PropTypes.string,
		name: PropTypes.string,
		building: PropTypes.string,
	}),
	buildings: PropTypes.array,
	updateBrochureHandler: PropTypes.func,
	togglePageListHandler: PropTypes.func,
	toggleControlsHandler: PropTypes.func,
	toggleGeneratePdfOpen: PropTypes.func,
}

export default translate('translations')(Brochure)
